<template>
    <div class="selectedMonth">
        <div class="kpi" v-for="value in values">
            <span class="label">{{value.label}}</span>
            <span v-if="isUnset(value.value)" class="value">{{props.unsetValue}}</span>
            <span v-else-if="typeof value.value === 'string'" class="value">{{value.value}}</span>
            <CountingNumber v-else class="value" :to="value.value" :formatter="value.formatter" />
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, ComputedRef, PropType, ref} from 'vue';
import {CalendarMonth} from "@/helper/calendar/calendarMonth";
import {DataLoader} from "@/helper/dataLoader";

import Skeleton from "@/components/Skeleton.vue";
import {Money, MonthKpi, MonthKpiProductivityScope} from "@/graphql/generated/graphql";

import {kapitelDateString} from '@/graphql/kapitelTypes';
import {useEmployeeStore} from "@/store/employee";
import {groupBy} from "@/helper/array";
import {ApexMonthRanger} from "@/helper/apexMonthRanger";
import {fetchMonthKPIList} from "@/helper/monthKPI/monthKPI";
import * as money from "@/helper/money";
import {generateApexOptions} from "@/helper/apexchart";
import month from "@/helper/datetime/month";
import {floatFormat} from "@/helper/amountFormatter";
import CountingNumber from '@/components/CountingNumber.vue';
import {isUnset} from "@/helper/isset";

// props
const props = defineProps({
    values: {
        type: Array as PropType<{label: string; value: number|Money|string|null|undefined, formatter?: (value: number|Money) => number|string}[]>,
        required: true,
    },
    unsetValue: {
        type: String,
        default: '-',
    }
});
</script>

<style lang="scss" scoped>
.selectedMonth {
    display: flex;
    .kpi {
        display: inline-block;

        .value, .label {
            display: inline-block;
            width: 100%;
        }

        .label {
            color: var(--ion-color-grey)
        }
        .value {
            font-weight: bold;
        }
    }
}
</style>
